const getDistinctPhoneNumbers = (phoneNumbers: ReadonlyArray<string | null | undefined>): ReadonlyArray<string> => [
  ...new Set(phoneNumbers.filter((phoneNumber): phoneNumber is string => Boolean(phoneNumber))),
]

export { getDistinctPhoneNumbers }
